import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';

export function registerIcons() {
  addIcons(allIcons);
}
